<!--
   @ 组件-流程信息块
-->
<template>
    <div style="width: 100%">
        <!-- <ul class="flow_chart">
            <li v-for="(item,i) in flowData.nodeList" :key="i"  :class="i<flowData.currentNode?'history activation':i==flowData.currentNode?'history activation current':''">
                <div>
                    <div :class="item.current?'yuan el-icon-check':'yuan'"></div>
                    <div class="jt"></div>
                    <span>{{item.elementName}}</span>
                </div>
            </li>
        </ul> -->
        <!-- <ul class="flow_chart">
            <li v-for="(item,i) in flowData.nodeList" :key="i"  :class="item.current ? 'history activation current': ((!item.current) && (item.auditHistorys === undefined || item.auditHistorys.length < 1)) ? '' : 'history activation'">
                <div>
                    <div :class="item.current?'yuan el-icon-check':'yuan'"></div>
                    <div class="jt"></div>
                    <span>{{item.elementName}}</span>
                </div>
            </li>
        </ul> -->
        <ul class="flow_chart" v-if="flowData.nodeList.length > 0">
            <li v-for="(item,i) in flowData.nodeList" :key="i"
                :class="currentNodeIndex==i?'current history':currentNodeIndex>=i?'history actived':''">
                <div>
                    <div :class="item.current||(currentNodeIndex>i) ?'yuan el-icon-check':'yuan'"></div>
                    <!--                    <div class="jt"></div>-->
                    <span>{{item.elementName}}</span>
                </div>
            </li>
        </ul>
        <el-table
                :data="flowTableData"
                border
                v-loading="dataListLoading"
                style="width: 100%;">
            <el-table-column
                    type="index"
                    header-align="center"
                    align="center"
                    label="序号"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="taskName"
                    header-align="center"
                    align="center"
                    width="120"
                    label="任务名称">
            </el-table-column>
            <el-table-column
                    prop="userName"
                    header-align="center"
                    align="center"
                    width="150"
                    label="执行人姓名">
            </el-table-column>
            <el-table-column
                    prop="excuteDate"
                    header-align="center"
                    align="center"
                    width="180"
                    label="执行人时间">
            </el-table-column>
            <el-table-column
                    prop="auditMsg"
                    header-align="center"
                    :show-overflow-tooltip="true"
                    align="center"
                    label="审核意见">
            </el-table-column>
        </el-table>
        <el-dialog title="审核意见"
                   :visible.sync="dialogVisible" width="30%"
                   :before-close="dialogCclose">
            <div class="dialogBox">
                <el-form ref="auditForm" :model="auditForm" :rules="dataRule" label-width="100px" class="form">
                    <el-form-item label="审核意见：" style="width:90%;" prop="suggest">
                        <el-input type="textarea" maxlength="100" :rows="5" show-word-limit
                                  v-model="auditForm.suggest"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="auditProcessSubmit" style="margin-bottom:20px;">确 定</el-button>
                <el-button @click="auditProcessCancel" class="backBtn">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        props: {
            processinstanceid: {
                type: String,
                defalut: ''
            },
            dialogVisible: {
                type: Boolean,
                defalut: false
            },
            businessId: {
                type: String,
                defalut: ''
            },
            bizType: {
                type: String, // bizType  ('1'自然人,'2'自然人变更,'3'法人,'4'法人变更)
                defalut: '1'
            },
            auditForm: {
                type: Object,
                defalut: () => ({
                    isPass: null,
                    suggest: ''
                })
            },
        },
        data() {
            return {
                dataListLoading: false,
                currentNodeIndex: "",//判断返回节点的current字段哪个为true
                dataRule: {
                    suggest: [
                        {required: true, message: '审核意见不能为空', trigger: 'blur'}
                    ],
                },
                flowData: {
                    nodeList: [],
                    currentNode: ''
                },
                flowTableData: [],
            };
        },
        created(){

        },
        activated(){

        },
        watch: {
            // flowData:{
            //     handler(newV, oldV){
            //         this.getLastNode()
            //     },
            //     deep:true
            // }
        },
        methods: {
            dialogCclose() {
                this.$emit("update:dialogVisible", false)
            },

            //获取流程
            getFlow(id) {
                this.$http.get(`/workflow/getinfo?processInstanceid=${id || this.processinstanceid}`).then(res => {
                    this.$emit('getFlowInfoSuccess', res.data.data);
                    // elementType === 2 的流程节点过滤掉
                    res.data.data.flowelements = res.data.data.flowelements.filter((item, index) => {
                        return item.elementType !== '2'
                    })
                    if (res.data.data.flowelements.length > 0) {
                        res.data.data.flowelements[0].elementName = '开始'
                        res.data.data.flowelements[res.data.data.flowelements.length - 1].elementName = '结束'
                    }
                    this.flowData.nodeList = res.data.data.flowelements;
                    this.getLastNode();
                    this.flowTableData = res.data.data.auditHistorys;
                    this.flowData.nodeList.map((item, index) => {
                        if (item.elementName === 'Start' || item.elementName === 'End') {
                            this.flowData.nodeList.splice(index, 1)
                        }
                    })
                    this.flowTableData.forEach(item => {
                        if (item.auditMsg === 'null') {
                            item.auditMsg = ''
                        }
                    })

                }).catch(e => {

                })
            },

            auditProcessSubmit() {
                this.$refs['auditForm'].validate((valid) => {
                    if (valid) {
                        this.$emit("auditProcessSubmit", this.auditForm)
                    }
                })

            },
            auditProcessCancel() {
                this.$emit("update:dialogVisible", false)
            },

            getLastNode() {
                for (var i in this.flowData.nodeList) {
                    if (this.flowData.nodeList[i].current) {
                        this.currentNodeIndex = i;
                        break;
                    }
                }
            }
        },
    };
</script>
<style lang="scss">
    .flow_chart{
        height: 100px;
        margin: 10px 0 -44px;
        display: flex;
        justify-content: space-evenly;
        li{
            width: 100%;
            position: relative;
            /*height: 50px;*/
            margin-top: 30px;
            list-style-type:none;
            &>div{
                width: 120px;
                /*height: 50px;*/
                /*border: 1px #BFBFBF solid;*/
                border-radius: 5px;
                background: #fff;
                position: absolute;
                left: 50%;
                top: 4%;
                transform: translate(-50%, -50%);
                z-index: 10;
                span{
                    display: block;
                    width: 100px;
                    position: absolute;
                    left: 50%;
                    top: -4%;
                    transform: translate(-50%, -50%);
                    color: #666666;
                    text-align: center;
                    cursor: default;
                }
                .el-icon-check:before {
                    content: "\e611";
                    margin: 1px 0px 1px 0px;
                    display: inline-block;
                }
                .jt{
                    position: absolute;
                    left: 50%;
                    top: -10px;
                    margin-left: -10px;
                    display: block;
                    width: 0;
                    height: 0;
                    border-width: 0 10px 10px;
                    border-style: solid;
                    border-color: transparent transparent #BFBFBF;
                    &:before{
                        content: '';
                        position: absolute;
                        left: 50%;
                        top: 1px;
                        margin-left: -9px;
                        display: block;
                        width: 0;
                        height: 0;
                        border-width: 0 9px 9px;
                        border-style: solid;
                        border-color: transparent transparent #fff;
                    }
                }
                .yuan{
                    position: absolute;
                    top: -42px;
                    left: 50%;
                    margin-left: -12px;
                    width: 24px;
                    height: 24px;
                    background: #fff;
                    border: 2px #BFBFBF solid;
                    border-radius: 50%;
                }
            }
            &:after{
                content: '';
                width: 50%;
                height: 2px;
                position: absolute;
                left: 0;
                top: -30px;
                background: #BFBFBF;
            }
            &:before{
                content: '';
                width: 50%;
                height: 2px;
                position: absolute;
                left: 50%;
                top: -30px;
                background: #BFBFBF;
            }
            &.history{
                &>div{
                    /*border: 1px #1965FF solid;*/
                    span{
                        color: #1965FF;
                    }
                    .jt{
                        border-color: transparent transparent #1965FF;
                    }
                    .yuan{
                        border: 2px #1965FF solid;
                    }
                }
                &:after{
                    background: #1965FF;
                }
                &:before{
                    background: #1965FF;
                }
                &.last{
                    &:before{
                        background: #BFBFBF;
                    }
                }
            }
            &.activation{
                &>div{
                    border: 1px #1965FF solid;
                    span{
                        color: #1965FF;
                    }
                    .jt{
                        border-color: transparent transparent #1965FF;
                    }
                    .yuan{
                        border: 2px #1965FF solid;
                    }
                }
                &:after{
                    background: #1965FF;
                }
                &:before{
                    background: #1965FF;
                }
            }
            &.actived{
                &>div{
                    span{
                        color: #1965FF;
                    }
                    .yuan{
                        background: #fff;
                        color: #1965FF;
                        &:before{
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }
            &.current{
                &>div{
                    /*background: #1965FF;*/
                    span{
                        /*color: #fff;*/
                    }
                    .jt{
                        &:before{
                            display: none;
                        }
                    }
                    .yuan{
                        background: #1965FF;
                        color: #fff;
                        &:before{
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }
        }
    }

</style>